import { confirm, DialogResponse } from 'owa-confirm-dialog';
import * as undoActions from 'owa-mail-undo';
import strings from 'owa-strings/owa-mail-strings';

/**
 * Helper method to trigger the confirm dialog before processing mark as phishing
 * @param markAsPhishingActionHandler callback after user confirms the mark as phishing action
 */
export default function confirmMarkAsPhishing(markAsPhishingActionHandler: () => void) {
    undoActions.clearLastUndoableAction();

    return confirm(
        strings.phishingDialogTitle,
        strings.phishingSubText,
        false /* resolveImmediately */,
        {
            okText: strings.reportPhishing,
            cancelText: strings.dontReportPhishing,

            // Wait until dialog is dismissed to avoid focus interruption
            delayCallbackAfterAnimation: true,
        }
    ).then((response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            markAsPhishingActionHandler();
        }
    });
}
